// components/LoadingSpinner.js
import { Loader2 } from "lucide-react";

const LoadingSpinner = ({ message = "Carregando..." }) => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: "20px",
      gap: "8px",
    }}>
    <Loader2 className="spin" size={32} />
    <p>{message}</p>
  </div>
);

export default LoadingSpinner;
